import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import './home_experiences.css';

class Experiences extends Component {
    render() {
        return (
            <div className="main">
            <Grid>
                <Row className="line-break"></Row>
                <Row className="show-grid">
                    <Col xs={12} sm={6} className="experiences-title">
                    <h1>Work</h1>
                    </Col>
                    <Col xs={12} sm={6} className="experiences-text">
                        <ul>
                            <li>Full Stack Developer Intern @ <a href="https://www.microsoft.com/en-ca">Microsoft</a> (Jan - Apr 2018)</li>
                            <p></p>
                            <li>Software Developer Intern @ <a href="http://code.hootsuite.com/co-ops/joy-zhang/">Hootsuite</a> (Sept - Dec 2017)</li>
                            <p></p>
                            <li>Computer Science Teaching Assistant @ <a href="https://www.ugrad.cs.ubc.ca/~cs100/2017W2/">University of British Columbia</a> (Sept 2016 - May 2017)</li>
                            <p></p>
                            <li>Robotics Instructor @ <a href="http://daedalosacademy.com/">Daedalos Academy</a> (Sept 2016 - May 2017)</li>
                        </ul>
                    </Col>
                </Row>
                <Row className="line-break"></Row>
                <Row className="show-grid">
                    <Col xs={12} sm={6} className="experiences-title">
                    <h1>Hackathons</h1>
                    </Col>
                    <Col xs={12} sm={6} className="experiences-text">
                        <ul>
                            <li><a href="https://devpost.com/software/eyedentify-pzskbt">EyeDentify</a> @ Dubhacks Seattle (Oct 2017)</li>
                            <p></p>
                            <li><a href="https://github.com/maknoon/chainsnakers">quizNET</a> @ Eduhacks (Sept 2017)</li>
                            <p></p>
                            <li>2nd place & Best Accessibility <a href="https://devpost.com/software/nwhacks2017-leaplanguage">Leap Language</a> @ NWHacks Vancouver (Mar 2017)</li>
                            <p></p>
                            <li><a href="https://devpost.com/software/msfthacks2017-cognition">Remember Me</a> @ MSFT Hacks Vancouver (Mar 2017)</li>
                        </ul>
                    </Col>
                </Row>
                <Row className="line-break"></Row>
                <Row className="show-grid">
                    <Col xs={12} sm={6} className="experiences-title">
                    <h1>Volunteer</h1>
                    </Col>
                    <Col xs={12} sm={6} className="experiences-text">
                        <ul>
                            <li>Project Lead - UBC Project Hub (Jan 2017 - May 2017)</li>
                            <p></p>
                            <li>Undergrad Student Representative - UBC Computer Science Department (Feb 2016 - May 2017)</li>
                            <p></p>
                            <li>Instructor - <a href="https://www.canadalearningcode.ca/program/girls-learning-code/">Girls Learning Code</a> (Apr 2016 - Feb 2017)</li>
                        </ul>
                    </Col>
                </Row>
                <Row className="line-break"></Row>
            </Grid>
            </div>
        );
    }
}

export default Experiences;



// WEBPACK FOOTER //
// ./src/components/home_experiences.js